import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const TwoFactorVerify = ({ QrCodeurll }) => {
  
  return (
   
      <QRCodeSVG
        value={QrCodeurll}
        size={128}

        level="H"
        style={{ marginBottom: "20px", backgroundColor:"white", borderRadius: "8px" }}
      />
   
  );
};

export default TwoFactorVerify;
